// =============================================================================
// PORTAL LOGIN PAGE (PortalLoginPage.js)
// =============================================================================
// Login form for the CDiC Upload Portal tab.
// Adapted from cdic-portal-react/client/src/pages/LoginPage.js
//
// KEY CHANGES:
// - Removed React Router (useNavigate, Link) — uses onNavigate prop instead
// - Import paths point to local portal files
// - CSS class names prefixed with cdic-portal-
// =============================================================================

import React, { useState } from 'react';
import { useAuth } from './PortalAuthContext';
import PortalLayout from './PortalLayout';
import PortalFlashMessage from './PortalFlashMessage';

function PortalLoginPage({ onNavigate }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('error');
  const [isLoading, setIsLoading] = useState(false);

  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');

    try {
      const data = await login(username, password);

      if (data.success) {
        onNavigate('upload');
      } else if (data.challenge === 'NEW_PASSWORD_REQUIRED') {
        onNavigate('new-password');
      } else {
        setMessage(data.message || 'Invalid username or password. Please try again.');
        setMessageType('error');
      }
    } catch (error) {
      setMessage('An error occurred. Please try again.');
      setMessageType('error');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PortalLayout showLogout={false} onNavigate={onNavigate}>
      <div className="cdic-portal-login-box">
        <h2>Login</h2>

        <form onSubmit={handleSubmit}>
          <div className="cdic-portal-input-container">
            <i className="material-icons">person</i>
            <input
              type="text"
              placeholder="Email"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="cdic-portal-input-container">
            <i className="material-icons">lock</i>
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="cdic-portal-forgot-password">
            <a
              href="#forgot"
              onClick={(e) => { e.preventDefault(); onNavigate('forgot-password'); }}
            >
              Forgot password?
            </a>
          </div>

          <button type="submit" disabled={isLoading}>
            {isLoading ? 'LOGGING IN...' : 'LOGIN'}
            {!isLoading && (
              <i className="material-icons" style={{ marginLeft: '5px' }}>arrow_forward</i>
            )}
          </button>
        </form>

        <PortalFlashMessage
          message={message}
          type={messageType}
          onClose={() => setMessage('')}
        />
      </div>
    </PortalLayout>
  );
}

export default PortalLoginPage;
